import React from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';
import {Button} from 'react-bootstrap';

export const HierarchyCell = ({value, row, className, onClickToggleChildren, onClickToTop}) => {
  let hasChildren = row.hasChildren;

  return (
    <StyledCell
      className={className}
      paddingLeft={row.absDepth > 0 ? row.absDepth * 16 + 8 : undefined}
      >
      <div>
        {
          !row.useGraphMode ?
            <Button
              bsStyle='primary'
              onClick={() => onClickToTop(row)}
              title='Open actions workflow'
              >
              <i className={`fa fa-arrow-to-top`}/>
            </Button> : null
        }
        {
          row.useGraphMode && hasChildren ?
            <Button
              bsStyle={row.isExpandedToDown ? 'default' : 'primary'}
              onClick={() => onClickToggleChildren(row)} title={`${row.isExpandedToDown ? 'Hide' : 'Show'} child action(s)`}
              >
              <i className={`fa ${row.isExpandedToDown ? 'fa-minus' : 'fa-plus'}`}/>
            </Button> : null
        }
      </div>
    </StyledCell>
  );
};

const StyledCell = styled.td`
  ${props => props.paddingLeft && css`
    padding-left: ${props.paddingLeft}px !important;
  `}
  ${props => props.paddingLeft && css`
    width: ${props.paddingLeft + 24 + 8}px !important;
  `}

  div {
    display: flex;
    flex-direction: column;
  }

  button {
    padding: 1px 0;
    width: 24px;
    & + button {
      margin-top: 5px;
    }
  }
`;

HierarchyCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.object,
  className: PropTypes.string,
  onClickDown: PropTypes.func,
  onClickToTop: PropTypes.func,
  useGraphMode: PropTypes.bool,
};
